<template>
  <fragment>
    <v-container fluid pa-0>
      <ValidationProvider v-slot="{ errors }" :rules="rules" :name="label" :vid="name">
          <CButton
                  v-if="options.length > 0"
                  class="ma-3"
                  outlined
                  small
                  fab
                  color="info"
                  @click="showModal = true"
          >
            商品選択
          </CButton>
        <input type="hidden" v-model="localValue" />

        <div v-if="errors" class="invalid-feedback" style="display: inline">{{errors[0]}}</div>
      </ValidationProvider>

    </v-container>

    <!-- modal -->
    <CModal
            color="success"
            :show.sync="showModal"
            title="商品選択"
    >

      <CheckboxCustomField
              v-model="localValue"
              :defaultValue="localValue"
              :name="name"
              :label="label"
              :rules="rules"
              :options="options"
              :text-key="textKey"
              :value-key="valueKey"
              :remarks="remarks"
              :disabled="disabled"
      ></CheckboxCustomField>

      <template #footer>
        <CButton
                color="primary"
                @click="showModal = false"
        >OK</CButton>
      </template>
    </CModal>
  </fragment>
</template>

<script>
import CheckboxCustomField from "./checkbox-custom";

export default {
  components: {
    CheckboxCustomField
  },
  props: {
    value: {},
    defaultValue: {
      type: Array,
      default: () => {return []}
    },
    options: {
      type: Array,
      required: true
    },
    textKey: {
      type: String,
      required: true
    },
    valueKey: {
      type: String,
      required: true
    },
    rules: {
      type: String
    },
    label: {
      type: String
    },
    name: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    entityProductIds: {
      type: Array,
      default: () => ([])
    },
    column: {
      type: Boolean,
      default: false
    },
    onchange: {
      default: () => {
      }
    },
    remarks: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
  },
  created(){
  }
};
</script>
<style module lang="scss">
.content-card {
  margin: 5px 0;
}
</style>
